export default __webpack_public_path__ + "static/media/home-application-testimonial-img02.59ff3d07.png";